// Phone number validation utility
export const validatePhoneNumber = (phone) => {
  // Remove all non-digit characters
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Check if it's exactly 10 digits
  if (cleanPhone.length !== 10) {
    return {
      isValid: false,
      error: 'Phone number must be exactly 10 digits'
    };
  }
  
  // Check if it contains only digits
  if (!/^\d{10}$/.test(cleanPhone)) {
    return {
      isValid: false,
      error: 'Phone number must contain only digits'
    };
  }
  
  return {
    isValid: true,
    cleanPhone: cleanPhone
  };
};

// Format phone number for display (adds dashes)
export const formatPhoneNumber = (phone) => {
  const cleanPhone = phone.replace(/\D/g, '');
  if (cleanPhone.length === 10) {
    return `${cleanPhone.slice(0, 3)}-${cleanPhone.slice(3, 6)}-${cleanPhone.slice(6)}`;
  }
  return phone;
};

// Clean phone number (remove all non-digits)
export const cleanPhoneNumber = (phone) => {
  return phone.replace(/\D/g, '');
}; 